import React from "react";
import { Header } from "semantic-ui-react";
import { InspectionItem } from "./InspectionItem";
import { InspectionItemType, InspectionSectionType } from "../../../queries/inspection-types/getInspectionType";
import { InspectionChecklistUtils } from "../../routes/InspectionChecklist";

interface Props {
  section: any;
  sectionType?: InspectionSectionType;
  inspectionId: any;
  handlePassItem?: (id: string, sectionId: string, itemId: string) => Promise<void>;
  handleFailItem?: (id: string, sectionId: string, itemId: string) => Promise<void>;
  inspectionStatus: any;
  user: "citizen" | "staff";
  sectionId: any;
}
export const InspectionSection = (props: Props) => {
  const { section, inspectionId, handlePassItem, handleFailItem, inspectionStatus, user, sectionId, sectionType } =
    props;

  const itemTypes = sectionType?.attributes?.items ?? [];
  const itemTypesMap = InspectionSectionUtils.getInspectionItemTypesMap(itemTypes);

  // The id used for scrolling the section into view
  const sectionElementId = InspectionChecklistUtils.getInspectionSectionElementId(sectionId);
  return (
    <div id={sectionElementId}>
      <Header> {section.title} </Header>
      {section.items.map((item: any) => {
        const inspectionItemTypeId = item?.data?.attributes?.["inspections-types-items-id"];
        const itemType = inspectionItemTypeId !== undefined ? itemTypesMap[inspectionItemTypeId] : undefined;
        const previousItemStatus = item?.data?.attributes?.["previous-item-status"];
        const previousItemCompletedDate = item?.data?.attributes?.["previous-item-completed-date"];
        return (
          <InspectionItem
            previousItemStatus={previousItemStatus}
            previousItemCompletedDate={previousItemCompletedDate}
            inspectionStatus={inspectionStatus}
            itemStatus={item.data.attributes.status}
            title={item.data.attributes.title}
            itemId={item.data.id}
            sectionId={sectionId}
            inspectionId={inspectionId}
            onPass={handlePassItem}
            onFail={handleFailItem}
            user={user}
            itemType={itemType}
            key={item.data.id}
          />
        );
      })}
    </div>
  );
};

class InspectionSectionUtils {
  /**
   * Creates a mapping of inspection item type ids to inspection item type objects.
   *
   * @param inspectionItemTypes an array of the inspection item type objects
   * @returns the mapping of inspection item type ids to inspection item type objects
   */
  static getInspectionItemTypesMap(inspectionItemTypes: InspectionItemType[]): Record<string, InspectionItemType> {
    const itemTypesMap: Record<string, InspectionItemType> = {};
    inspectionItemTypes.forEach((itemType) => {
      if (itemType.id === undefined) return;
      itemTypesMap[itemType?.id.toString()] = itemType;
    });
    return itemTypesMap;
  }
}
